import React, {Component} from 'react';
import PropTypes from 'prop-types';
import "./renderSearch.scss"
import {checkWidth} from "../../utils";

/**
 * creat by tianruojun
 * creat at 2023.2.16
 * @description 通用渲染表格上方筛选区组件
 * @class RenderSearch
 * @extends {Component}
 */
export default class RenderSearch extends Component {
    static propTypes = {
        /**
         * @text 初始部门id
         * @category data
         */
        deptId: PropTypes.string,
        /**
         * @text 点击弹窗确认按钮后的回调
         * @category event
         */
        onSelect: PropTypes.func
    };
    static defaultProps = {
        deptId: '0',
        onSelect: (dept, call) => {
            call && call(true)
        }
    };

    /**
     * 处理睡觉的回调
     * @param {string} name 姓名
     */
    onSleep = (name) => {
        this.setState({name})
    };

    constructor(props) {
        super(props);
        this.state = {
            // 数据层
            params: {

            },
            // 展现层
            input: {

            },
            // 页面加载时的原始参数
            defaultParams: {

            }

        }

        if(this.props.defaultStateData) {
            this.state = {
                ...this.state,
                ...JSON.parse(JSON.stringify(this.props.defaultStateData))
            }

        }

    }

    componentWillMount() {


    }

    componentDidMount() {
        const observer = new ResizeObserver(e=>{
            e.forEach(entry=>{
                this.props.onResize(entry.target.offsetHeight);
            });
        });
        const target = document.querySelector('.render-search');
        observer.observe(target)
    }
    /**
     * 表单子项onChange
     * @param {string} code 字段存储位置
     * @param {string|object|array} val 字段值
     * @param {boolean} setState 是否需要刷新页面
     */
    onInformationChange = ({labelCode,code, val, setState = false, fun,call,component}) => {
        if(fun) {
            this.executeFun({fun,call,component});
            return;
        }

        if (val instanceof Array && labelCode instanceof Array) {
            this.executeArray({labelCode, code, val, setState, fun, call});
            return;
        }
        this.executeObj({labelCode, code, val, setState, fun, call});
    };

    // 点击查询按钮
    onSearch = () => {
        const {onSearch} = this.props;
        if(typeof onSearch === "function") {
            this.advance(()=>{
                this.console();
                onSearch(this.state.params)
            });
        }
    };

    // 页面加载时首次加载数据
    onSearchDefault = () => {
        this.state.defaultParams = {...this.state.input};
        this.onSearch();
    };

    // 点击重置按钮
    onReset = ({call,component}) => {

        let noRestData = {};
        let noRestKey = component?.config?.noRestKey;
        if(noRestKey?.length) {
            for(let i=0;i<noRestKey.length;i++ ) {
                let key  = noRestKey[i]
                noRestData[key] = this.state.params[key]
            }
        }
        this.state.params = {...this.state.defaultParams,...noRestData};
        this.state.input = {...this.state.defaultParams,...noRestData};
        this.setState({},()=>{
            this.onSearch();
        });
    };

    // 参数回退
    rollback = (call) => {
        this.state.input = {...this.state.params};
        this.setState({},()=>{
            call&&call()
        });
    };

    // 参数前进
    advance = (call) => {
        this.state.params = {...this.state.input};
        call&&call()
    };

    executeFun = ({fun,call,component}) => {
        if(this[fun]) {
            this[fun]({call,component});
        }
    };

    onExport = ({call,component}) => {
        let request = component?.config?.request;
        let url = request?.url;
        let method = request?.method;
        let contentType = request?.contentType;
        let params = request?.params;
        const {onExport} = this.props;
        if(url && method && params && onExport) {
            onExport({url,method,contentType,params})
        }
    };

    executeArray = ({labelCode, val, setState, call}) => {
        if (labelCode instanceof Array) {
            labelCode.forEach((item, index) => {
                if (val[index] || val[index] === null) {
                    this.state.input[item] = val[index];
                }
            });
            if (setState) {
                this.setState({}, () => {
                    this.console()
                    call && call()
                });
            }
        }
    };

    console = () => {
        // console.log("params",this.state.params)
        // console.log("input",this.state.input)
        // console.log("defaultParams",this.state.defaultParams)
    };

    executeObj = ({labelCode,code,val,setState,call}) => {
        // 将值存在对应位置
        this.state.input[labelCode] = val;
        // eval(`${code}=val`);
        // 方案一 eval(`obj.${key}=value`);
        // 方案二 new Function('obj','key','value',`obj.${key}=value`)(obj,key,value);
        // 备注：只有动态字段需要使用${}包裹
        if (setState) {
            this.setState({},()=>{
                this.console()
                call&&call()
            });
        }
    };


    getValueByCode = (labelCode) => {
        if(labelCode instanceof Array) {
            return this.getValueByCodeByArr(labelCode)
        } else {
            return this.getValueByCodeByObj(labelCode)
        }
    };
    getValueByCodeByArr = (labelCode) => {
        let value = [];
        labelCode.forEach((item,index)=>{
            value.push(this.state.input[item])
        });
        return value
    };
    getValueByCodeByObj = (labelCode) => {
        return this.state.input[labelCode]
    };

    setDefaultValue =  (labelCode,defaultValue) => {
        if(labelCode instanceof Array) {
            this.setDefaultValueByArr(labelCode,defaultValue)
        } else {
            this.setDefaultValueByObj(labelCode,defaultValue)
        }
    };

    setDefaultValueByArr = (labelCode,defaultValue) => {
        labelCode.forEach((item,index)=>{
            if(defaultValue[index]) {
                this.state.input[item] = defaultValue[index];
            }
        });
    };

    setDefaultValueByObj = (labelCode,defaultValue) => {
        if(labelCode && this.state.input[labelCode]===undefined && defaultValue !== undefined) {
            this.state.input[labelCode] = defaultValue
        }
    };

    // 渲染行
    renderRow = (row,index) => {
        if(!row?.length) {
            return ""
        }
        // 通过当前展示区最大宽度与当前行按钮宽度进行比对，如果超出则适当调节按钮之间的距离和按钮大小
        let {marginRight=24,scale=1} = checkWidth(row,24,30+64);
        return (
            <div className={"row"} key={index}>
                {
                    row.map((col,index)=>{
                        let m = marginRight;
                        if(index == row.length-1) {
                            m = 0
                        }
                        return this.renderCol(col,index,m,scale)
                    })
                }
            </div>
        )
    };

    // 渲染列
    renderCol = (col,index,marginRight,scale) => {
        let style = col?.style || {};
        return (
            <div className={"col"} key={index} style={{...style}}>
                {this.renderBtn(col,scale)}
            </div>
        )
    };

    // 渲染一个按钮
    renderBtn = ({
                     component={},
                     labelCode = "",
                     placeholder = "请输入",
                     defaultValue,
                     disabled = false,
                     id = "",
                     size = "default",
                     sameDay=false
                 },scale) => {
        let Component = null;

        let componentName = component?.name;

        if (!componentName || (typeof componentName !== "string")) return console.log("字段不合法");

        try {
            Component = require(`./item/${componentName}/${componentName}`);
            Component = Component.default
        } catch (e) {
            console.log(e.toString())
        }
        this.setDefaultValue(labelCode,defaultValue);
        let onChange = ({labelCode, val, fun,call}) => {
            this.onInformationChange({labelCode, val, setState: true, fun,call,component})
        };
        let value = this.getValueByCode(labelCode);
        return (
            Component ?
                <Component
                    value={value}
                    onChange={onChange}
                    config={component?.config}
                    labelCode={labelCode}
                    size={size}
                    scale={scale}
                    disabled={disabled}
                    id={id}
                    sameDay={sameDay}
                    placeholder={placeholder}
                />
                : null
        )
    };

    render() {
        const {searchConfig=[]} = this.props.config;
        if(!searchConfig?.length) {
            return ""
        }
        return (
            <div className={"render-search"}>
                {
                    searchConfig.map((row,index)=>{
                        return this.renderRow(row,index)
                    })
                }
            </div>
        )
    }

}